module.exports = __webpack_public_path__ + "static/Moonlighter2-c3a9a6d55a629313e6f54e952946b915.png";